import { render, staticRenderFns } from "./InquiryComplete.vue?vue&type=template&id=713b1320&"
import script from "./InquiryComplete.vue?vue&type=script&lang=ts&"
export * from "./InquiryComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports